import React from 'react'
import { Link } from 'react-router-dom'
import { Menu, Icon, Header } from 'semantic-ui-react'

const Navbar = ({ authenticated, isDeployed, deploySidebar, dockSidebar }) => {
  const menuButtonClick = isDeployed ? dockSidebar : deploySidebar
  return (
    <Menu
      fixed="top"
      inverted
      style={{
        background: 'linear-gradient(180deg,#04376f,#3872b5)',
      }}
    >
      {authenticated && (
        <Menu.Item onClick={menuButtonClick}>
          <Icon name="content" />
        </Menu.Item>
      )}
      <Menu.Item header>
        <Link style={{ marginRight: 12 }} to="/">
          <Header as="h1" inverted>
            Painscale Admin
          </Header>
        </Link>
      </Menu.Item>
    </Menu>
  )
}

export default Navbar
